import { gql } from "@apollo/client";

const ADD_CATEGORY_POINTS = gql`
  mutation createRankingCategoryPoint(
    $createRankingCategoryPointInput: [CreateRankingCategoryPointInput!]!
  ) {
    createRankingCategoryPoint(createRankingCategoryPointInput: $createRankingCategoryPointInput) {
      id
    }
  }
`;

export default ADD_CATEGORY_POINTS;
